<div class="simulator-page d-flex flex-column min-vh-100 bg-light">
  <header
    class="simulator-header d-flex align-items-center bg-white border-bottom px-4 py-2"
  >
    <img
      src="assets/img/logo.png"
      alt="PureSpectrum Logo"
      class="logo mx-auto"
    />
  </header>

  <main
    class="simulator-container flex-grow-1 d-flex justify-content-center py-5 px-3"
  >
    <div class="card simulator-card border-0 shadow-sm w-100">
      <div class="card-body p-4">
        <h2 class="h5 text-center mb-4 text-dark fw-bold">Pick One</h2>

        <div class="choice-list">
          <div
            *ngFor="let choice of answerChoices"
            class="choice-item d-flex align-items-center justify-content-between p-3 mb-2 rounded"
            role="button"
            tabindex="0"
            (click)="initiateRedirection(choice.status)"
            (keyup.enter)="initiateRedirection(choice.status)"
          >
            <div class="d-flex align-items-center">
              <div
                class="radio-mock bg-white border rounded-circle flex-shrink-0"
              ></div>
              <span class="ms-3 text-dark">{{ choice.text }}</span>
            </div>
            <small class="text-muted fst-italic"
              >Status: {{ choice.status }}</small
            >
          </div>

          <div class="choice-item custom-choice p-3 rounded border mt-4">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <label for="custom-status" class="small text-secondary mb-0"
                >Specify Status:</label
              >
              <input
                id="custom-status"
                type="number"
                class="form-control form-control-sm ms-2 custom-status-input flex-grow-1"
                [(ngModel)]="status"
                placeholder="e.g. 15"
              />
              <button
                psUiButton
                class="btn btn-primary btn-sm ms-auto px-4"
                [disabled]="!status"
                (click)="initiateRedirection(status!)"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <ps-footer-copyright></ps-footer-copyright>
</div>
